module.exports = __webpack_public_path__ + "img/UserOtherInterests.015e8a6d.svg";